/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, { Component } from 'react';
import FileIcons from 'file-icons-js';

import Subnav from '../subnav';
import Button from '../form/Button';
import OrganizationApi from '../../api/organization';
import FileApi from '../../api/file';

import withEhsPageBehavior from '../../withEhsPageBehavior';

class AllFilesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationName: '',
            files: [],
            downloadLink: null,
            isDownloading: false,
            complete: false,
            completeMessage: '',
        };

        this.downloadFile = this.downloadFile.bind(this);
        this.downloadAllFiles = this.downloadAllFiles.bind(this);
    }

    orgId = this.props.match.params.organizationId;

    componentWillMount() {
        OrganizationApi.get(this.orgId).then(org => {
            this.setState({
                organizationName: org.name,
            });
        });
        FileApi.getAllFiles(this.orgId).then(files => {
            this.setState({ files: files.map(file => file) });
        });
    }

    downloadFile(evt, file) {
        // This bit of monkey business is because we have to generate a signed
        // link in AWS to send to the user. These links are good only for a
        // limited amount of time, so we generate them on demand. That said,
        // we still want these links to download a file when the user clicks
        // it. So, we generate the url and initiate a click event on a hidden
        // link so that the pop-up blockers don't block us.
        const criterionId = file.criterion_id;
        const filename = file.file_key;
        const fileId = file.s3_id;
        FileApi.getDownloadURL(criterionId, filename, fileId).then(url => {
            this.setState({ downloadLink: url }, () => {
                this.hiddenLink.click();
            });
        });
    }

    downloadAllFiles() {
        this.setState({
            isDownloading: true,
            complete: false,
        });
        FileApi.downloadAllFiles(this.state.files)
            .then(response => {
                this.setState({
                    isDownloading: false,
                    complete: true,
                    completeMessage: response,
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    isDownloading: false,
                    complete: true,
                    completeMessage:
                        'There was an error in the request. Try again.',
                });
            });
    }

    render() {
        const {
            organizationName,
            isDownloading,
            files,
            complete,
            completeMessage,
        } = this.state;
        return (
            <main className="page">
                <div className="page__subnav">
                    <Subnav
                        organizationId={this.props.match.params.organizationId}
                    />
                </div>
                <div className="page__header">
                    <h2>{organizationName}</h2>
                </div>
                <div className="page__body">
                    <div className="AllFiles">
                        <div className="AllFiles__titlebar">
                            <h2>Organization Files</h2>
                        </div>
                        <div className="form__buttons">
                            <Button
                                isbusy={isDownloading}
                                onClick={this.downloadAllFiles}
                                defaultText="Download All"
                                icon="fa-download"
                                size="small"
                            />
                        </div>
                        {isDownloading ? (
                            <div className="download-message">
                                Zipping all files and sending a link to your
                                email. This might take a few minutes, depending
                                on file sizes and how many.
                            </div>
                        ) : null}
                        {complete ? (
                            <div className="download-message">
                                {completeMessage}
                            </div>
                        ) : null}
                        <div className="AllFilesList">
                            {files.map(file => {
                                const icon = FileIcons.getClass(file.s3_id);
                                let downloadLink = (
                                    <a
                                        onClick={evt =>
                                            this.downloadFile(evt, file)
                                        }>
                                        <i className={icon}></i>
                                        {file.s3_id}
                                    </a>
                                );
                                return (
                                    <div className="File_wrapper" key={file.id}>
                                        <a
                                            ref={hiddenLink =>
                                                (this.hiddenLink = hiddenLink)
                                            }
                                            download={file.s3_id}
                                            href={this.state.downloadLink}
                                            className="hidden">
                                            {this.state.downloadLink}
                                        </a>
                                        <div>{downloadLink}</div>
                                        <div className="criterion-info">
                                            Criterion: {file.criterion.name}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default withEhsPageBehavior(AllFilesPage);
